import React from 'react';
import CountrySelect from '../CountrySelect';
import {BiArrowBack, BiX} from 'react-icons/bi';
import './styles.scss';
import {DataPoint, GroupedData} from '../../App';
import FilteredDetail from '../FilteredDetail';
import CountryDetail from '../CountryDetail';
import classNames from 'classnames';
import LinkDetail from '../LinkDetail';
// import SearchBar from '../SearchBar';
import {useParams} from 'react-router-dom';
import ReactSwitch from 'react-switch';

interface DrawerProps {
  id: string | null;
  searchValue: string;
  hasFilters: boolean;
  setId: (id: string) => void;
  groupedData: GroupedData;
  data: DataPoint[];
  filteredData: DataPoint[];
  filteredCity: string | null;
  goBack: () => void;
  hideMap: boolean;
  setHideMap: (hideMap: boolean) => void;
}

const Drawer = ({
  id,
  setId,
  searchValue,
  groupedData,
  data,
  filteredData,
  filteredCity,
  hasFilters,
  goBack,
  hideMap,
  setHideMap,
}: DrawerProps) => {
  const params = useParams();
  const {view} = params;

  const dataPoint = data.find((d) => d.id === id);
  const idOrFilters = id || hasFilters;

  return (
    <div
      className={classNames([
        'Drawer',
        {'hide-map': id || hideMap},
        {visible: idOrFilters},
      ])}
      key={view}
    >
      <div className="anchored-header">
        <div className="back-header" onClick={() => goBack()} >
          {(id && hasFilters) ? (
            <>
              <BiArrowBack className="back-button" />
              <p className="back-button-text">Back</p>
            </>
          ) : (
            <>
              <BiX className="back-button" />
              <p className="back-button-text">Close</p>
            </>
          )}
        </div>
      </div>
      <div className={classNames(['scrollable-content'])}>
        {hasFilters && (
          <div className="detail-container">
            <FilteredDetail data={filteredData} />
          </div>
        )}
        {id && (
          <div className="detail-container">
            <LinkDetail dataPoint={dataPoint} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Drawer;
